import { mergeStyleSets } from '@fluentui/react';

export const commmonStyles = mergeStyleSets({
	visuallyHidden: {
		left: '-1000px',
		top: '-1000px',
		width: 0,
		height: 0,
		position: 'fixed',
		overflow: 'hidden'
	},
	layoutContainer: {
		padding: '2rem'
	}
});
